module.exports = __webpack_public_path__ + "img/15.12ec7f11.webp";